import axios from 'axios'

class UserService {
  static addVisitor () {
    return axios.post('api/visitors')
  }
};

export default UserService
